<template>
  <div aria-hidden="true" class="stash-backdrop fixed inset-0 z-behind bg-black/50" data-test="stash-backdrop">
    <slot></slot>
  </div>
</template>
